import React, { useEffect, useState } from "react";
import { FilterIcon, Arrow } from "../Images/svgs";
import axiosClient from "../axios-client";
import ProjectCard from "./Partials/ProjectCard";
import { useStateContext } from "../Providers/ContextProvider";
import FixedButton from "./Partials/FixedButton";
// import WorldMap from "./WorldMap";

// function Projects({ NumberInput, Categories }) {

const CategoriesA = [
  {
    id: 1,
    title: "Education",
    description: "Projects related to educational initiatives",
  },
  {
    id: 2,
    title: "Health",
    description: "Health and medical aid projects",
  },
  {
    id: 3,
    title: "Infrastructure",
    description: "Development of infrastructure like roads, schools, etc.",
  },
  {
    id: 4,
    title: "Emergency Relief",
    description: "Providing urgent relief in times of disaster",
  },
];

function Projects({ NumberInput, Categories = CategoriesA }) {
   // const { projectData, setprojectData } = useStateContext();

  const [projectData, setprojectData] = useState([
    {
      id: 1,
      title: "خلوة الامام الطبري",
      images: {
        image:
          "https://i.ibb.co/8KcrML6/465515713-18047723030506037-3586469520068209461-n.jpg",
      },
      updated_at: "2023-11-01T12:00:00Z",
      project_value: 5000,
    },
    {
      id: 2,
      title: "خلوة قرية لانا",
      images: {
        image:
          "https://i.ibb.co/7CKwStk/465750345-18047723057506037-1964922867198231648-n.jpg",
      },
      updated_at: "2023-11-05T08:00:00Z",
      project_value: 12000,
    },
    {
      id: 3,
      title: "مشروع إنارة",
      images: {
        image:
          "https://i.ibb.co/7JrT45M/465820547-18047722988506037-1525478395742935929-n.jpg",
      },
      updated_at: "2023-11-07T10:00:00Z",
      project_value: 8000,
    },
    {
      id: 4,
      title: "إعادة الأمل",
      images: {
        image:
          "https://i.ibb.co/frYGNDJ/465820639-18047723021506037-5373095694920165724-n.jpg",
      },
      updated_at: "2023-11-09T15:00:00Z",
      project_value: 15000,
    },
    {
      id: 5,
      title: "إنارة الأمل",
      images: {
        image:
          "https://i.ibb.co/4NB6r94/465852172-18047723009506037-3006684529859806868-n.jpg",
      },
      updated_at: "2023-11-10T18:00:00Z",
      project_value: 9000,
    },
    {
      id: 6,
      title: "المساعدة بتفرق",
      images: {
        image:
          "https://i.ibb.co/s1GRg1r/465886823-18047968454506037-3788874869299833563-n.jpg",
      },
      updated_at: "2023-11-11T09:00:00Z",
      project_value: 4000,
    },
    {
      id: 7,
      title: "معاناة السودان",
      images: {
        image:
          "https://i.ibb.co/2FsLt1s/466039883-18047968436506037-6288437755155844775-n.jpg",
      },
      updated_at: "2023-11-12T14:00:00Z",
      project_value: 20000,
    },
  ]);

  const [showlist, setShowlist] = useState(false);
  const [activeLink, setActiveLink] = useState("projects");
  const [currentPage, setCurrentPage] = useState(1);
  const [toggleComponent, setToggleComponent] = useState(false);

  const handleLinkClick = (event, linkText) => {
    event.preventDefault();
    setActiveLink(linkText);
  };

  const showList = () => {
    setShowlist(!showlist);
  };

  const HandleLoadMore = () => {
    const nextPage = currentPage + 1;
    setCurrentPage(nextPage);
  };

  //   const getProjects = (Taps) => {
  //     axiosClient
  //       .get(`https://project.alkhair.weblayer.info/api/${Taps}`, {
  //         params: {
  //           limit: NumberInput,
  //           page: currentPage,
  //         },
  //       })
  //       .then((response) => {
  //         setprojectData((prevData) => [...prevData, ...response.data.data.data]);
  //       })
  //       .catch((error) => {
  //         console.error("Error:", error);
  //       });
  //   };

  //   useEffect(() => {
  //     getProjects(activeLink);
  //   }, [activeLink, currentPage, NumberInput]);

  const toggle = () => {
    setToggleComponent(!toggleComponent);
  };

  return (
    <>
      {!toggleComponent ? (
        <>
          {Categories && Categories.length > 0 && (
            <div id="targetDiv" className="container max-w-7xl mx-auto">
              <div className="flex flex-col bg-white pt-10 px-10 pb-6 mt-10 rounded-[15px] space-y-6">
                <div className="flex flex-row justify-between items-center mb-5 gap-10">
                  <div className="flex-1 text-sm font-medium text-center text-gray-500 border-b border-gray-200">
                    <ul className="flex flex-wrap -mb-px">
                      {Categories &&
                        Categories.length > 0 &&
                        Categories.map((category, index) => (
                          <li key={index} className="me-2">
                            <a
                              href="#"
                              className={`inline-block p-4 border-b-2 border-transparent rounded-t-lg ${
                                activeLink === category
                                  ? "text-blue-600 border-b-2 border-b-blue-600"
                                  : ""
                              }`}
                              onClick={(e) => handleLinkClick(e, category)}
                            >
                              {/* {category.title} */}
                              {category.value}
                            </a>
                          </li>
                        ))}
                    </ul>
                  </div>
                  <div className="flex-0">
                    <button
                      onClick={showList}
                      id="dropdownHoverButton"
                      data-dropdown-toggle="dropdownHover"
                      data-dropdown-trigger="hover"
                      className="flex-row gap-2 text-black border-2 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center outline-none"
                      type="button"
                    >
                      <FilterIcon />
                      التصنيف حسب
                      <Arrow />
                    </button>
                    {showlist && (
                      <div
                        id="dropdownHover"
                        className="z-10 absolute bg-white divide-y divide-gray-100 rounded-lg shadow w-44"
                      >
                        <ul
                          className="py-2 text-sm text-gray-700"
                          aria-labelledby="dropdownHoverButton"
                        >
                          <li>
                            <a
                              href="#"
                              className="block px-4 py-2 hover:bg-gray-100"
                            >
                              Dashboard
                            </a>
                          </li>
                          <li>
                            <a
                              href="#"
                              className="block px-4 py-2 hover:bg-gray-100"
                            >
                              Settings
                            </a>
                          </li>
                          <li>
                            <a
                              href="#"
                              className="block px-4 py-2 hover:bg-gray-100"
                            >
                              Earnings
                            </a>
                          </li>
                          <li>
                            <a
                              href="#"
                              className="block px-4 py-2 hover:bg-gray-100"
                            >
                              Sign out
                            </a>
                          </li>
                        </ul>
                      </div>
                    )}
                  </div>
                </div>
                <div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 grid-flow-row">
                    {projectData.map((project, index) => (
                      <ProjectCard project={project} key={`project_${index}`} />
                    ))}
                  </div>
                </div>
                <div className="text-center">
                  <button
                    className="border rounded-lg px-5 py-3"
                    onClick={HandleLoadMore}
                  >
                    تحميل المزيد
                  </button>
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        <>
          {/* <WorldMap /> */}
        </>
      )}
      <FixedButton toggle={toggle} toggleComponent={toggleComponent} />
    </>
  );
}

export default Projects;
